import React, { useState, useEffect, useMemo } from 'react'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import SaleForm from './SaleForm'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import { StatusPill, ActionIconButton, ListPageShell, SideDrawer, EmptyState } from '../../Components/Ui'

const Sale = ({ nameSingle, namePlural, separator }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})
    const [typeFilter, setTypeFilter] = useState('')
    const [dashboardFilter, setDashboardFilter] = useState('')
    const [localSearch, setLocalSearch] = useState('')
    const [tableFilter, setTableFilter] = useState('')

    useEffect(() => {
        if (reload) {
            setIsProccesing(true)
            Controllers.sale.get_sale().then(res => {
                setRows(res.data)
            }).catch(req => Helpers.promise.catch({ req, toast }))
                .finally(() => {
                    setIsProccesing(false)
                    setReload(false)
                })
        }
    }, [reload])

    const filteredRows = useMemo(() => {
        return (rows || []).filter(r => {
            if (typeFilter && r.type_sale !== typeFilter) return false
            if (dashboardFilter === '1' && parseInt(r.show_dashboard_sale) !== 1) return false
            if (dashboardFilter === '0' && parseInt(r.show_dashboard_sale) === 1) return false
            return true
        })
    }, [rows, typeFilter, dashboardFilter])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.sale.sale_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataUpdated({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setLoadSubmit(false)
                setReload(true)
            })
    }

    const handleGet = e => {
        let $this = e.currentTarget

        if (!$this.dataset?.idSale) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({})
            setModalShow(true);
            return
        }

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idSale } = $this.dataset

        Controllers.sale.get_sale_id({ p_id_sale: idSale }).then(res => {
            setModalTitle(`Modificar ${nameSingle} #${idSale}`)
            setDataUpdated({ data: res.data })
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setReload(true)
        })
            .finally(() => $this.innerHTML = buttonHTML)
    }

    const handleOpenCreate = () => {
        setModalTitle(`Registrar ${nameSingle}`)
        setDataUpdated({})
        setModalShow(true)
    }

    const handleDelete = () => {
        setLoadSubmitDelete(true)

        Controllers.sale.sale_delete(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setReload(true)
                setLoadSubmitDelete(false)
            })
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const handleShowModalDelete = e => {
        let { idSale, descriptionSale } = e.currentTarget.dataset
        setDataDeleted({
            p_id_sale: idSale,
            p_description_sale: descriptionSale
        })
        setShowConfirmDelete(true)
    }

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const applySearch = () => setTableFilter(localSearch)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        textFilter={tableFilter}
        hideSearch
        head={[
            [
                { name: 'id_sale', text: 'ID', align: 'center' },
                {
                    name: 'description_sale', text: 'Tienda', render: r => (
                        <div className="sp-cell-main">
                            <strong>{r.description_sale}</strong>
                            {r.amount_sale ? <span className="sp-cell-meta">{r.amount_sale}</span> : null}
                        </div>
                    )
                },
                {
                    name: 'type_sale', align: 'center', text: 'Resultado', render: s => {
                        let color = 'secondary'
                        switch (s.type_sale) {
                            case 'Negro':
                                color = 'dark'
                                break;
                            case 'Rojo':
                                color = 'danger'
                                break;
                            case 'Estrella':
                                color = 'warning'
                                break;
                        }
                        return <StatusPill tone={color}>{s.type_sale}</StatusPill>
                    }
                },
                {
                    name: 'show_dashboard_sale', text: 'Escritorio', align: 'center', render: r => <StatusPill tone={parseInt(r.show_dashboard_sale) === 1 ? 'success' : 'secondary'}>
                        {parseInt(r.show_dashboard_sale) === 1 ? 'Visible' : 'Oculto'}
                    </StatusPill>
                },
                {
                    name: 'actions', text: 'Acciones', align: 'center', render: u => {
                        return <div className="sp-row-actions">
                            <ActionIconButton tone="ghost" icon="fa fa-pen" label="Editar" data-id-sale={u.id_sale} onClick={handleGet} />
                            <ActionIconButton tone="danger" icon="fa fa-trash" label="Eliminar" data-id-sale={u.id_sale} data-description-sale={u.description_sale} onClick={handleShowModalDelete} />
                        </div>
                    }
                },
            ],
        ]}
        rows={filteredRows}
        isProcessing={isProcessing}
    />, [filteredRows, isProcessing, tableFilter])

    const showEmpty = !isProcessing && filteredRows.length === 0

    return <>
        <ListPageShell
            eyebrow="Super Papelera — Espacio de trabajo"
            title={`Listado de ${namePlural}`}
            subtitle="Consulta información, completa tareas y toma decisiones desde un solo lugar."
            badge="Actividad actualizada"
            primaryAction={
                <ListPageShell.PrimaryButton onClick={handleOpenCreate} icon="fa fa-plus">
                    Registrar {nameSingle}
                </ListPageShell.PrimaryButton>
            }
            onSearch={applySearch}
            filters={[
                {
                    label: 'Resultado',
                    control: (
                        <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)}>
                            <option value="">Todos</option>
                            <option value="Rojo">Rojo</option>
                            <option value="Negro">Negro</option>
                            <option value="Estrella">Estrella</option>
                        </select>
                    )
                },
                {
                    label: 'Escritorio',
                    control: (
                        <select value={dashboardFilter} onChange={e => setDashboardFilter(e.target.value)}>
                            <option value="">Todos</option>
                            <option value="1">Visible</option>
                            <option value="0">Oculto</option>
                        </select>
                    )
                },
                {
                    label: 'Buscar',
                    control: (
                        <input
                            type="search"
                            placeholder="Tienda, resultado…"
                            value={localSearch}
                            onChange={e => setLocalSearch(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') applySearch() }}
                        />
                    )
                }
            ]}
        >
            {showEmpty ? (
                <EmptyState
                    icon="fa fa-store"
                    title={`No hay ${namePlural.toLowerCase()} para mostrar`}
                    text="Ajusta los filtros o registra una nueva tienda para empezar."
                    action={
                        <ListPageShell.PrimaryButton onClick={handleOpenCreate}>
                            Registrar {nameSingle}
                        </ListPageShell.PrimaryButton>
                    }
                />
            ) : (
                <div className="sp-table-wrap">{dtRows}</div>
            )}
        </ListPageShell>

        <SideDrawer
            open={modalShow}
            onClose={handleHideModalForm}
            title={modalTitle}
            subtitle="Los cambios se guardan al confirmar el formulario."
        >
            <SaleForm onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} />
        </SideDrawer>

        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_sale} - {dataDeleted.p_description_sale}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />
    </>
}

export default Sale
